/**
 * Desktop top padding for nav headers that sit under the Tauri title bar.
 * `isShellAnchored` means the header is already below ScribeLayout's titlebar
 * padding, so it only needs breathing room; a viewport-fixed header clears
 * the bar itself.
 */
export const getDesktopHeaderPaddingClass = ({
  isInsetDesignEnabled,
  isShellAnchored,
}: {
  isInsetDesignEnabled: boolean | undefined;
  isShellAnchored: boolean;
}) => {
  if (isShellAnchored) return isInsetDesignEnabled ? 'pt-4' : 'pt-2';
  return isInsetDesignEnabled ? 'pt-12' : 'pt-10';
};
